import { Box, Modal, Typography, useTheme,Button, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit'
import { tokens } from "../../theme";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import Form from "./form";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { json, useLocation } from "react-router-dom";
import swal from "sweetalert"
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import Tooltip from '@mui/material/Tooltip';
import { jwtDecode } from "jwt-decode";


const Team = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [showModal,setShowModal] = useState(false)
  const [usersData,setUsersData] = useState([])
  const [formData,setFormData] = useState(null)
  const [cookies,setCookie] = useCookies(['token'])
  const location = useLocation()
  const decoded = jwtDecode(cookies["token"])
  const jsonData = JSON.parse(decoded.userInfo)
  const fetchUser = async()=>{
   
    let userTypes = [];

    if (location.pathname.includes("user")) {
      userTypes.push("Admin");
    } else if (location.pathname.includes("company")) {
      userTypes.push("Company Admin", "Company User");
    } else {
      userTypes.push("Company User");
    }
  
    let allData = [];
  
    for (let userType of userTypes) {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/user/all/${userType}`, {
        headers: {
          Authorization: "Bearer " + cookies['token']
        }
      });
      if(response.status!==200){
        setCookie("token",null)
        return
      }
    if (response.ok) {
      const data = await response.json();
      allData = allData.concat(data);
    } else {
      console.error(`Failed to fetch data for userType: ${userType}`);
    }
  }    setUsersData(()=>{
      return allData.filter((us)=>jsonData.companies.id===1|| us.company.id===jsonData.companies.id).map((usr,ind)=>({...usr,name:usr.full_name,access:usr.role?usr.role.name:null,no:ind+1}))
    })
  }

  useEffect(()=>{
    fetchUser()
  },[location])

  const callbackAfterSubmit = ()=>{
    fetchUser().then(()=>{
      setShowModal(false)
    })
  }

  const editUser = (row)=>{
    setShowModal(true)
    setFormData(row)
  }

  const deleteUser = (id)=>{
    const resp = window.confirm("Are You Sure?")
    if(resp){
      fetch(process.env.REACT_APP_BACKEND_URL+"/user/delete/"+id,{method:"DELETE",headers:{
        Authorization:"Bearer "+cookies['token']
      }}).then((res)=>{
        setUsersData((prev)=>{
          return prev.filter(dt=>dt.id!==id)
        })
      }).catch(()=>{
          setCookie("token",null)
      })
    }
  }

  const toggleEnableStatus = async (userId, currentStatus) => {
    let confirmationMessage;
    switch (currentStatus) {
        case true:
            confirmationMessage = "Are you sure you want to disable?";
            break;
        case false:
            confirmationMessage = "Are you sure you want to enable?";
            break;
        default:
            confirmationMessage = "Are you sure you want to switch status?";
    }
    const confirmed = window.confirm(confirmationMessage);
    if (!confirmed) return;
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/user/${userId}/toggleEnable`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookies['token']
        },
        body: JSON.stringify({ enable: !currentStatus }) 
      });
  
      const responseData = await response.json();
      if (response.ok) {
        swal("Success", responseData.message, "success");
        window.location.reload();
      } else {
        if (response.status === 401) {
          setCookie("token", null);
          swal("Failed", responseData.message, "error");
        } else if (response.status === 404) {
          swal("Failed", responseData.message, "error");

        } 
      }
    } catch (error) {
      console.error('Error toggling user enable status:', error);
      swal("Failed", "Error toggling user enable status. Please try again", "error");
    }
  }
  
  let columns = [
    { field: "no", headerName: "No",flex: 0.5, },
    {
      field: "name",
      headerName: "Name",
      flex: 1.5,
      cellClassName: "name-column--cell",
    },
    // {
    //   field: "username",
    //   headerName: "Username",
    //   flex: 1,
    //   cellClassName: "name-column--cell",
    // },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
    },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   flex: 1,
    // },
    {
      field: "Company",
      headerName: "Company",
      flex: 1,
      renderCell:({ row }) => {
        return (
          <Box>
              <Typography>{row.company&&row.company?row.company.name:""}</Typography>
          </Box>
        );
      },
    },
   
    // {
    //   field: "accessLevel",
    //   headerName: "Access Level",
    //   flex: 1,
    //   renderCell: ({ row: { access } }) => {
    //     return (
    //       <Box
    //         width="60%"
    //         m="0 auto"
    //         p="5px"
    //         display="flex"
    //         justifyContent="center"
    //         borderRadius="4px"
    //       >
    //         {access === "admin" && <AdminPanelSettingsOutlinedIcon />}
    //         {access === "customer" && <SecurityOutlinedIcon />}
    //         {access === "user" && <LockOpenOutlinedIcon />}
    //         <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
    //           {access}
    //         </Typography>
    //       </Box>
    //     );
    //   },
    // },
    {
      field: "Account_number",
      headerName: "Account Number",
      flex: 2,
      renderCell: ({ row }) => {
        const accountNumbers = row.accounts.map(account => account.account_number);
        const formattedAccountNumbers = `[${accountNumbers.join(", ")}]`;
        return (
          <Box>
            <Typography>{formattedAccountNumbers}</Typography>
          </Box>
        );
      },
    },
    {
      field: "Role",
      headerName: "Role",
      flex: 1,
      renderCell:({ row }) => {
        return (
          <Box>
              <Typography>{row.role&&row.role?row.role.name:""}</Typography>
          </Box>
        );
      },
    },
    
    {
      field: "_enabled",
      headerName: "Status",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row._enabled ? "green" : "red";
        const transactionType = row._enabled ? "Enabled" : "Disabled";
        const icon = { transactionType, style: { color: iconColor } };
        return (
          <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
            <span style={{ color: iconColor }}>{icon.transactionType}</span>
          </Typography>
        );
      }
    }
,    
{
      field: "Action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row._enabled ?"green":"red";
        const icon = row._enabled ? 
        (
          <Tooltip title="Enable User" arrow>
            <ToggleOnIcon style={{ color: iconColor, fontSize: '40px' }} />
          </Tooltip>
        ):
        (
          <Tooltip title="Disable User" arrow>
            <ToggleOffIcon style={{ color: iconColor, fontSize: '40px'}} />
          </Tooltip>
        ) 
        return (
          <Box>
            <IconButton onClick={() => toggleEnableStatus(row.id, row._enabled)}>
              <Typography color={colors.black[500]} sx={{ ml: "5px", mt:"10px"}}>
                {icon}
              </Typography>
            </IconButton>
            <IconButton onClick={()=>editUser(row)}>
              <EditIcon style={{color:"#2196f3"}} title="Edit"/>
            </IconButton>
            {jsonData.roles.name!=="Company Admin"?(
            <IconButton onClick={()=>deleteUser(row.id)}>
              <DeleteIcon style={{color:"red"}}/>
            </IconButton>
            ):(null)}
          </Box>
        );
      }
}

  ];

  if(jsonData.roles.name==='Company User'){
    columns.pop();
  }
  if(location.pathname.includes("user")){
    columns = columns.filter(cl=>cl.headerName!=="Company"&&cl.headerName!=="Account Number")
  }
  const handleClose = ()=>{
    setShowModal(false);
    setFormData(null)
  }

  return (
    <AuthGuard>
    <Box m="10px">
    <Modal open={showModal} onClose={handleClose}>
      <Form callBackAfterSubmit={callbackAfterSubmit} formData={formData}/>
    </Modal>
    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
      <Header subtitle={"Manage "+(location.pathname.includes("user")?"Users":"Users")} />
      {jsonData.roles.name!=="Company User"&&
      <Button variant="contained" sx={{height:"2rem",width:"10rem",boxSizing:"border-box",background:"#1A8D90",color:"#fff"}} onClick={()=>setShowModal(true)}>
               {location.pathname.includes("user")?"Add User":"Add User"}
        </Button>
}
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-row:nth-child(odd)': {
            border: "1px solid white",
            backgroundColor: theme.palette.mode === 'light' ? colors.white[300] : "#F3F5F8",
          },
          '& .MuiDataGrid-iconSeparator': {
            display: 'none',
          },
          "& .MuiDataGrid-overlay": {
            border: "none",
          },
          "& .MuiDataGrid-root": {
            border: "1px solid white",
          },
          "& .MuiDataGrid-row": {
            border: "1px solid white",

          },
          "& .MuiDataGrid-cell": {
            fontSize: 15,
            color: colors.black[500],
            border: "none !important",

          },
          "& .name-column--cell": {
            fontWeight: "bold",
            color: colors.black[500],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.white[500],
            color: colors.black[900],
            fontSize: 20,
            border: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: "bold",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[500],
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: colors.white[500],
            border: "none",

          },
          "& .MuiDataGrid-pagination": {
            "& .MuiTablePagination-menuItem": {
              color: "#000000",
            },
          },
          "& .MuiTablePagination-root": {
            color: "#000000",
          },
          "& .MuiSvgIcon-root ": {
            color: "#000000",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            left: "75%", /* Position the element at the center horizontally */
            transform: `translateX(-75%)`,
            color: `${colors.black[500]} !important`,
          },
            "& .MuiDataGrid-row:hover": {
            backgroundColor: "none",
            },
        }}
      >
        <DataGrid rows={usersData} columns={columns} />
      </Box>
    </Box>
    </AuthGuard>
  );
};

export default Team;
